import * as Yup from "yup";

export const insuranceSchema = () =>
  Yup.object({
    payorId: Yup.string()
      .trim()
      .max(7, "Payor ID cannot be more than 7 characters.")
      .required("Payor ID is required"),
    payorName: Yup.string()
      .trim()
      .max(100, "Insurance name cannot be more than 100 characters.")
      .required("Insurance Name is required"),
    street: Yup.string()
      .trim()
      .max(100, "Street address cannot be more than 100 characters."),
    city: Yup.string()
      .trim()
      .max(25, "City cannot be more than 25 characters."),
    state: Yup.string(),
    zip: Yup.string().trim().max(15, "Zip cannot be more than 15 characters."),
    phone: Yup.string()
      .trim()
      .max(20, "Phone cannot be more than 20 characters."),
  });
